export default __webpack_public_path__ + "static/desk_background-b16c726b2051a0feec9ad9fdb597f520.jpg";